export class AuthError extends Error {
  override name = 'Auth Error';

  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, AuthError.prototype);
  }
}
